import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { StoreAccountModel } from "@store/Framework/Types/ApiModels";

export interface AddAccountApiParameter extends ApiParameter {
    account: Partial<StoreAccountModel>;
}

const accountsUrl = "api/v1/account-activation/activate";

export async function storeCreateAccount(parameter: AddAccountApiParameter): Promise<ServiceResult<StoreAccountModel>> {
    try {
        const accountModel = await post<StoreAccountModel>(`${accountsUrl}`, parameter.account as StoreAccountModel);
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
